import AnimatedLottieView from "@utils/lottieAnimation";
import React from "react";
import type { StyleProp, ViewStyle } from "react-native";
import { StyleSheet } from "react-native";
import { Title, View, Text } from "@constants/Themed";
import Animated from "react-native-reanimated";
import { SizableText } from "tamagui";
import { themeSelector } from "@reduxLocal/selectors/themeSelector";

interface Props {
  style?: StyleProp<ViewStyle>
  index: number,
  data?: any
}

export const SBTextItem: React.FC<Props> = ({ style, index, data }) => {
  const theme = themeSelector();
  return data[index] && (
    <Animated.View style={[styles.container, { minHeight: 350 }, style]}>
      <Title adjustsFontSizeToFit allowFontScaling={false} style={{ flex: 2, fontSize: 20 }}>{data[index]?.title}</Title>
      <View style={{ flex: 4, padding: 10,}}>
        {data[index]?.image}
      </View>
      <SizableText allowFontScaling={false} adjustsFontSizeToFit style={{ color: theme ? "black" : "white", flex: 3, lineHeight: 30, }} >{data[index]?.caption}</SizableText>
    </Animated.View >
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: '100%',
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    alignContent: 'center',
    textAlign: 'center',
    alignSelf: 'center',
    padding: 15,
  },
});